const TYPES = {
    GET_CONSENT: 'GET_CONSENT',
    GET_CONSENT_COMPLETE: 'GET_CONSENT_COMPLETE',
    GET_CONSENT_FAILED: 'GET_CONSENT_FAILED',
    GET_TAX_PROFILE: 'GET_TAX_PROFILE',
    GET_TAX_PROFILE_COMPLETE: 'GET_TAX_PROFILE_COMPLETE',
    GET_TAX_PROFILE_FAILED: 'GET_TAX_PROFILE_FAILED',
    GET_TAX_INTERVIEW: 'GET_TAX_INTERVIEW',
    GET_TAX_INTERVIEW_COMPLETE: 'GET_TAX_INTERVIEW_COMPLETE',
    GET_TAX_INTERVIEW_FAILED: 'GET_TAX_INTERVIEW_FAILED',
    GET_ORGANIZATIONS: 'GET_ORGANIZATIONS',
    GET_ORGANIZATIONS_COMPLETE: 'GET_ORGANIZATIONS_COMPLETE',
    GET_ORGANIZATIONS_FAILED: 'GET_ORGANIZATIONS_FAILED',
    GET_TAX_RECORD: 'GET_TAX_RECORD',
    GET_TAX_RECORD_COMPLETE: 'GET_TAX_RECORD_COMPLETE',
    GET_TAX_RECORD_FAILED: 'GET_TAX_RECORD_FAILED',
    RETAKE_INTERVIEW: 'RETAKE_INTERVIEW',
    RETAKE_INTERVIEW_COMPLETE: 'RETAKE_INTERVIEW_COMPLETE',
    RETAKE_INTERVIEW_FAILED: 'RETAKE_INTERVIEW_FAILED',
    UPDATE_TAX_RECORD: 'UPDATE_TAX_PROFILE',
    UPDATE_TAX_RECORD_COMPLETE: 'UPDATE_TAX_PROFILE_COMPLETE',
    UPDATE_TAX_RECORD_FAILED: 'UPDATE_TAX_PROFILE_FAILED',
    GET_BALANCE_PAYABLE: 'GET_BALANCE_PAYABLE',
    GET_BALANCE_PAYABLE_COMPLETE: 'GET_BALANCE_PAYABLE_COMPLETE',
    GET_BALANCE_PAYABLE_FAILED: 'GET_BALANCE_PAYABLE_FAILED',
    GET_RECORD_RETAKE_AVAILABLE: 'GET_RECORD_RETAKE_AVAILABLE',
    GET_RECORD_RETAKE_UPDATE_COMPLETE: 'GET_RECORD_RETAKE_ABLE_COMPLETE',
    GET_RECORD_RETAKE_UPDATE_FAILED: 'GET_RECORD_RETAKE_ABLE_FAILED',
    GET_RECORD_EMAIL: 'GET_RECORD_EMAIL',
    GET_RECORD_EMAIL_COMPLETE: 'GET_RECORD_EMAIL_COMPLETE',
    GET_RECORD_EMAIL_FAILED: 'GET_RECORD_EMAIL_FAILED',
    REFRESH_TAX_RECORD: 'REFRESH_TAX_RECORD',
    REFRESH_TAX_RECORD_COMPLETE: 'REFRESH_TAX_RECORD_SUCCESS',
    REFRESH_TAX_RECORD_FAILED: 'REFRESH_TAX_RECORD_FAILED',
    CONSENT_FOR_PAYMENT: 'CONSENT_FOR_PAYMENT',
    CONSENT_FOR_PAYMENT_COMPLETE: 'CONSENT_FOR_PAYMENT_COMPLETE',
    CONSENT_FOR_PAYMENT_FAILED: 'CONSENT_FOR_PAYMENT_FAILED',
    RESET_INTERVIEW: 'RESET_INTERVIEW',
    RESET_DIALOG: 'RESET_DIALOG'
};

export default {
    TYPES,

    consentForPayment: payload => ({
        type: TYPES.CONSENT_FOR_PAYMENT,
        payload
    }),

    consentForPaymentSuccess: payload => ({
        type: TYPES.CONSENT_FOR_PAYMENT_COMPLETE,
        payload
    }),

    consentForPaymentFailed: payload => ({
        type: TYPES.CONSENT_FOR_PAYMENT_FAILED,
        payload
    }),

    getConsent: () => ({
        type: TYPES.GET_CONSENT
    }),

    getConsentSuccess: payload => ({
        type: TYPES.GET_CONSENT_COMPLETE,
        payload
    }),

    getConsentFailed: payload => ({
        type: TYPES.GET_CONSENT_FAILED,
        payload
    }),

    resetInterview: () => ({
        type: TYPES.RESET_INTERVIEW
    }),

    resetDialog: () => ({
        type: TYPES.RESET_DIALOG
    }),

    getBalancePayable: () => ({
        type: TYPES.GET_BALANCE_PAYABLE
    }),

    getBalancePayableSuccess: payload => ({
        type: TYPES.GET_BALANCE_PAYABLE_COMPLETE,
        payload
    }),

    getBalancePayableFailed: payload => ({
        type: TYPES.GET_BALANCE_PAYABLE_FAILED,
        payload
    }),

    updateTaxRecord: payload => ({
        type: TYPES.UPDATE_TAX_RECORD,
        payload
    }),

    updateTaxRecordSuccess: payload => ({
        type: TYPES.UPDATE_TAX_RECORD_COMPLETE,
        payload
    }),

    updateTaxRecordFailed: payload => ({
        type: TYPES.UPDATE_TAX_RECORD_FAILED,
        payload
    }),

    retakeInterview: payload => ({
        type: TYPES.RETAKE_INTERVIEW,
        payload
    }),

    retakeInterviewSuccess: payload => ({
        type: TYPES.RETAKE_INTERVIEW_COMPLETE,
        payload
    }),

    retakeInterviewFailed: payload => ({
        type: TYPES.RETAKE_INTERVIEW_FAILED,
        payload
    }),

    getRecordEmail: payload => ({
        type: TYPES.GET_RECORD_EMAIL,
        payload
    }),

    getRecordEmailSuccess: payload => ({
        type: TYPES.GET_RECORD_EMAIL_COMPLETE,
        payload
    }),

    getRecordEmailFailed: payload => ({
        type: TYPES.GET_RECORD_EMAIL_FAILED,
        payload
    }),

    getTaxRecord: payload => ({
        type: TYPES.GET_TAX_RECORD,
        payload
    }),

    getTaxRecordSuccess: payload => ({
        type: TYPES.GET_TAX_RECORD_COMPLETE,
        payload
    }),

    getTaxRecordFailed: payload => ({
        type: TYPES.GET_TAX_RECORD_FAILED,
        payload
    }),

    getTaxProfile: () => ({
        type: TYPES.GET_TAX_PROFILE
    }),

    getTaxProfileSuccess: () => ({
        type: TYPES.GET_TAX_PROFILE_COMPLETE
    }),

    getTaxProfileFailed: () => ({
        type: TYPES.GET_TAX_PROFILE_FAILED
    }),

    getRatakeAvailable: paylaod => ({
        type: TYPES.GET_RECORD_RETAKE_AVAILABLE,
        paylaod
    }),

    getUpdateAvailableSuccess: payload => ({
        type: TYPES.GET_RECORD_RETAKE_UPDATE_COMPLETE,
        payload
    }),

    getRatakeAvailableFailed: payload => ({
        type: TYPES.GET_RECORD_RETAKE_UPDATE_FAILED,
        payload
    }),

    getTaxInterviewURL: payload => ({
        type: TYPES.GET_TAX_INTERVIEW,
        payload
    }),

    getTaxInterviewURLSuccess: payload => ({
        type: TYPES.GET_TAX_INTERVIEW_COMPLETE,
        payload
    }),

    getTaxInterviewURLFailed: payload => ({
        type: TYPES.GET_TAX_INTERVIEW_FAILED,
        payload
    }),

    refreshTaxRecord: payload => ({
        type: TYPES.REFRESH_TAX_RECORD,
        payload
    }),

    refreshTaxRecordComplete: payload => ({
        type: TYPES.REFRESH_TAX_RECORD_COMPLETE,
        payload
    }),

    refreshTaxRecordFailed: payload => ({
        type: TYPES.REFRESH_TAX_RECORD_FAILED,
        payload
    }),

    getOrganizations: payload => ({
        type: TYPES.GET_ORGANIZATIONS,
        payload
    }),

    getOrganizationsSuccess: payload => ({
        type: TYPES.GET_ORGANIZATIONS_COMPLETE,
        payload
    }),

    getOrganizationsFailed: payload => ({
        type: TYPES.GET_ORGANIZATIONS_FAILED,
        payload
    })
};
